import { OPERATION_STATE } from "./actions";

export function setOperation(payload) {
  return {
    type: OPERATION_STATE,
    operation_data: payload.operation_data,
    project_data: payload.project_data,
  };
}
